module.exports = __webpack_public_path__ + "assets/img/xcx.f49e965a.png";